<content>

    <section class="filters-framed" *ngIf="filtersVisible">
        <form [formGroup]="filtersForm">
            <div *ngIf="filtersForm.get('pais')" [ngClass]="this.isSmallScreen ? 'entry-4-small' : 'entry-4'">
                <label>{{'global.pais' | translate}}</label>
                <app-multiselect-list 
                    [itemsList]="paises" 
                    (shareCheckedList)="shareCheckedListPaises($event)"
                    [selectedItem]="filtersForm.get('pais')"
                    initialState="noSelected">
                </app-multiselect-list>
            </div>
            <div *ngIf="filtersForm.get('denominacion')" [ngClass]="this.isSmallScreen ? 'entry-4-small' : 'entry-4'">
                <label>{{'central-avisos.etiquetadores.innerFilters.denominacion' | translate}}</label>
                <app-multiselect-list 
                    [itemsList]="denominaciones" 
                    (shareCheckedList)="shareCheckedListDenominaciones($event)"
                    [selectedItem]="filtersForm.get('denominacion')"
                    initialState="noSelected">
                </app-multiselect-list>
            </div>
            <div *ngIf="filtersForm.get('etiquetador')" [ngClass]="this.isSmallScreen ? 'entry-4-small' : 'entry-4'">
                <label>{{'central-avisos.etiquetadores.innerFilters.etiquetador' | translate}}</label>
                <app-multiselect-list 
                    [itemsList]="etiquetadores" 
                    (shareCheckedList)="shareCheckedListEtiquetadores($event)"
                    [selectedItem]="filtersForm.get('etiquetador')"
                    initialState="noSelected">
                </app-multiselect-list>
            </div>
            <div *ngIf="filtersForm.get('porcentajeEtiquetado')" [ngClass]="this.isSmallScreen ? 'entry-4-small' : 'entry-4'">
                <label>{{'global.porcentajeConfeccionado' | translate}} ></label>
                <input type="number" formControlName="porcentajeEtiquetado">
            </div>
            <div *ngIf="filtersForm.get('porcentajeReetiquetado')" [ngClass]="this.isSmallScreen ? 'entry-4-small' : 'entry-4'">
                <label>{{'central-avisos.etiquetadores.innerFilters.porcentajeReetiquetado>' | translate}}</label>
                <input type="number" formControlName="porcentajeReetiquetado">
            </div>
            <div *ngIf="filtersForm.get('reimpresiones')" [ngClass]="this.isSmallScreen ? 'entry-4-small' : 'entry-4'">
                <label>{{'central-avisos.etiquetadores.innerFilters.reimpresiones' | translate}}</label>
                <input type="number" formControlName="reimpresiones">
            </div>
            <div *ngIf="filtersForm.get('usuario')" [ngClass]="this.isSmallScreen ? 'entry-4-small' : 'entry-4'">
                <label>{{'central-avisos.etiquetadores.innerFilters.usuario' | translate}}</label>
                <input type="text" formControlName="usuario">
            </div>
            <div *ngIf="filtersForm.get('nombre')" [ngClass]="this.isSmallScreen ? 'entry-4-small' : 'entry-4'">
                <label>{{'central-avisos.etiquetadores.innerFilters.nombre' | translate}}</label>
                <input type="text" formControlName="nombre">
            </div>
            <div *ngIf="filtersForm.get('apellido')" [ngClass]="this.isSmallScreen ? 'entry-4-small' : 'entry-4'">
                <label>{{'central-avisos.etiquetadores.innerFilters.apellido' | translate}}</label>
                <input type="text" formControlName="apellido">
            </div>
            <!-- <div *ngIf="filtersForm.get('rol')" [ngClass]="this.isSmallScreen ? 'entry-4-small' : 'entry-4'">
                <label>Rol</label>
                <app-multiselect-list 
                    [itemsList]="roles" 
                    (shareCheckedList)="shareCheckedListRoles($event)"
                    [selectedItem]="filtersForm.get('rol')"
                    initialState="noSelected">
                </app-multiselect-list>
            </div> -->
            <div *ngIf="filtersForm.get('numAlmacenes')" [ngClass]="this.isSmallScreen ? 'entry-4-small' : 'entry-4'">
                <label>{{'central-avisos.etiquetadores.innerFilters.numAlmacenes' | translate}}</label>
                <input type="number" formControlName="numAlmacenes">
            </div>
        </form>
    </section>
    <section class="filters-buttons">
        <button *ngIf="!filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="Filtrar">
            <i class="fas fa-filter"></i> {{'global.filtros.filtrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.cerrar' | translate}}">
            <i class="fas fa-times"></i> {{'global.filtros.cerrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary"
            [ngClass]="{'showFilters': filtersVisible}" (click)="filtersForm.reset()"
            title="{{'global.filtros.limpiar' | translate}}">
            <i class="fas fa-eraser"></i> {{'global.filtros.limpiar' | translate}}
        </button>
        <button *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            title="{{'global.filtros.aplicar' | translate}}" (click)="filtrar()">
            <i class="fas fa-filter"></i> {{'global.filtros.aplicar' | translate}}
        </button>
    </section>

    <div *ngIf="showExpedicionCero" class="table-wrapper no-m-bottom">
        <table>
            <thead>
                <tr>
                    <th class="string sortable sortable-bigger" [appSort]="dataExpedicionCeroDiasDisplayed" data-order="desc" data-name="desPais" (click)="toOrderBy(1)">
                        {{'global.pais' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(1)"></i>
                        </div>
                    </th>
                    <th class="string sortable sortable-bigger" [appSort]="dataExpedicionCeroDiasDisplayed" data-order="desc" data-name="desDenominacion" (click)="toOrderBy(2)">
                        {{'central-avisos.etiquetadores.expedicionCero.denominacion' | translate}}
                        <div class="sortable-icons sort-icons-padding">
                            <i [ngClass]="getSortIcon(2)"></i>
                        </div>
                    </th>
                    <th class="date sortable sortable-bigger" [appSort]="dataExpedicionCeroDiasDisplayed" data-order="desc" data-name="campanyaFechaInicio" data-type="date" (click)="toOrderBy(3)">
                        {{'central-avisos.etiquetadores.expedicionCero.inicioCampanya' | translate}}
                        <div class="sortable-icons sort-icons-padding">
                            <i [ngClass]="getSortIcon(3)"></i>
                        </div>
                    </th>
                    <th class="string sortable sortable-biggest" [appSort]="dataExpedicionCeroDiasDisplayed" data-order="desc" data-name="desEtiquetador" (click)="toOrderBy(4)">
                        {{'central-avisos.etiquetadores.expedicionCero.etiquetador' | translate}}
                        <div class="sortable-icons sort-icons-padding">
                            <i [ngClass]="getSortIcon(4)"></i>
                        </div>
                    </th>
                    <th class="date sortable sortable-bigger" [appSort]="dataExpedicionCeroDiasDisplayed" data-order="desc" data-name="fechaPrimerConsumo" data-type="date" (click)="toOrderBy(5)">
                        {{'central-avisos.etiquetadores.expedicionCero.primerConsumo' | translate}}
                        <div class="sortable-icons sort-icons-padding">
                            <i [ngClass]="getSortIcon(5)"></i>
                        </div>
                    </th>
                    <th class="string sortable sortable-bigger" [appSort]="dataExpedicionCeroDiasDisplayed" data-order="desc" data-name="numDiasSinImprimir" (click)="toOrderBy(6)">
                        {{'central-avisos.etiquetadores.expedicionCero.diasSinConfeccionar' | translate}}
                        <div class="sortable-icons sort-icons-padding">
                            <i [ngClass]="getSortIcon(6)"></i>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody *ngFor="let data of dataExpedicionCeroDiasDisplayed; let i = index">
                <tr *ngIf="i < lastItemList && i >= firstItemList">
                    <td class="string">{{data.desPais}}</td>
                    <td class="string">{{data.desDenominacion}}</td>
                    <td class="date">{{data.campanyaFechaInicio | date:"short": undefined : defaultLanguage}}</td>
                    <td class="string-longest">{{data.desEtiquetador}}</td>
                    <td class="date">{{data.fechaPrimerConsumo | date:"short": undefined : defaultLanguage}}</td>
                    <td class="string">{{data.numDiasSinImprimir ? data.numDiasSinImprimir : 'central-avisos.etiquetadores.expedicionCero.sinConsumos' | translate}}</td>
                </tr>
            </tbody>
            <tfoot *ngIf="!dataExpedicionCeroDiasDisplayed || (dataExpedicionCeroDiasDisplayed && dataExpedicionCeroDiasDisplayed.length < 1)">
                <tr>
                  <td colspan="6">
                    {{'global.noContent' | translate}}
                  </td>
                </tr>
            </tfoot>
        </table>
    </div>
    
    <div *ngIf="showExpedicionDesignados" class="table-wrapper no-m-bottom">
        <table >
            <thead>
                <tr>
                    <th class="string sortable sortable-bigger" [appSort]="dataDisplayed" data-order="desc" data-name="desPais" (click)="toOrderBy(1)">
                        {{'global.pais' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(1)"></i>
                        </div>
                    </th>
                    <th class="string sortable sortable-bigger" [appSort]="dataDisplayed" data-order="desc" data-name="desDenominacion" (click)="toOrderBy(2)">
                        {{'central-avisos.etiquetadores.expedicionDesignados.denominacion' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(2)"></i>
                        </div>
                    </th>
                    <th class="string sortable sortable-biggest" [appSort]="dataDisplayed" data-order="desc" data-name="desEtiquetador" (click)="toOrderBy(3)">
                        {{'central-avisos.etiquetadores.expedicionDesignados.etiquetador' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(3)"></i>
                        </div>
                    </th>
                    <th class="number sortable sortable-biggest" [appSort]="dataDisplayed" data-order="desc" data-name="sumKilosEfectivos" (click)="toOrderBy(4)">
                        {{'global.confeccionadoKg' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(4)"></i>
                        </div>
                    </th>
                    <th class="number sortable sortable-biggest" [appSort]="dataDisplayed" data-order="desc" data-name="sumKgDesignados" (click)="toOrderBy(5)">
                        {{'central-avisos.etiquetadores.expedicionDesignados.designados' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(5)"></i>
                        </div>
                    </th>
                    <th class="number sortable sortable-bigger" [appSort]="dataDisplayed" data-order="desc" data-name="porcentaje" (click)="toOrderBy(6)">
                        {{'global.porcentajeConfeccionado' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(6)"></i>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody *ngFor="let row of dataDisplayed; let i = index">
                <tr *ngIf="i < lastItemList && i >= firstItemList">
                    <td class="string">{{row.desPais}}</td>
                    <td class="string">{{row.desDenominacion}}</td>
                    <td class="string-longest">{{row.desEtiquetador}}</td>
                    <td class="number-longest">{{row.sumKilosEfectivos | number : '1.2-2': defaultLanguage}}</td>
                    <td class="number-longest">{{row.sumKgDesignados | number : '1.2-2': defaultLanguage}}</td>
                    <td class="number">{{row.porcentaje | number : '1.2-2': defaultLanguage}}</td>
                </tr>
            </tbody>
            <tfoot *ngIf="!dataDisplayed || (dataDisplayed && dataDisplayed.length < 1)">
                <tr>
                  <td colspan="6">
                    {{'global.noContent' | translate}}
                  </td>
                </tr>
            </tfoot>
        </table>
    </div>
    
    <div *ngIf="showReetiquetados" class="table-wrapper no-m-bottom">
        <table>
            <thead>
                <tr>
                    <th class="string sortable sortable-bigger" [appSort]="dataDisplayed" data-order="desc" data-name="desPais" (click)="toOrderBy(1)">
                        {{'global.pais' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(1)"></i>
                        </div>
                    </th>
                    <th class="string sortable sortable-bigger" [appSort]="dataDisplayed" data-order="desc" data-name="desDenominacion" (click)="toOrderBy(2)">
                        {{'central-avisos.etiquetadores.reetiquetado.denominacion' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(2)"></i>
                        </div>
                    </th>
                    <th class="string sortable sortable-biggest" [appSort]="dataDisplayed" data-order="desc" data-name="desEtiquetador" (click)="toOrderBy(3)">
                        {{'central-avisos.etiquetadores.reetiquetado.etiquetador' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(3)"></i>
                        </div>
                    </th>
                    <th class="number sortable sortable-biggest" [appSort]="dataDisplayed" data-order="desc" data-name="sumKgReimpresos" (click)="toOrderBy(4)">
                        {{'central-avisos.etiquetadores.reetiquetado.reimpresos' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(4)"></i>
                        </div>
                    </th>
                    <th class="number sortable sortable-biggest" [appSort]="dataDisplayed" data-order="desc" data-name="sumKilosEfectivos" (click)="toOrderBy(5)">
                        {{'global.confeccionadoKg' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(5)"></i>
                        </div>
                    </th>
                    <th class="number sortable sortable-bigger" [appSort]="dataDisplayed" data-order="desc" data-name="porcentaje" (click)="toOrderBy(6)">
                        {{'central-avisos.etiquetadores.reetiquetado.porcentaje' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(6)"></i>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody *ngFor="let row of dataDisplayed; let i = index">
                <tr *ngIf="i < lastItemList && i >= firstItemList">
                    <td class="string">{{row.desPais}}</td>
                    <td class="string">{{row.desDenominacion}}</td>
                    <td class="string-longest">{{row.desEtiquetador}}</td>
                    <td class="number-longest">{{row.sumKgReimpresos | number : '1.2-2': defaultLanguage}}</td>
                    <td class="number-longest">{{row.sumKilosEfectivos | number : '1.2-2': defaultLanguage}}</td>
                    <td class="number">{{row.porcentaje | number : '1.2-2': defaultLanguage}}</td>
                </tr>
            </tbody>
            <tfoot *ngIf="!dataDisplayed || (dataDisplayed && dataDisplayed.length < 1)">
                <tr>
                  <td colspan="6">
                    {{'global.noContent' | translate}}
                  </td>
                </tr>
            </tfoot>
        </table>
    </div>
    
    <div *ngIf="showEtiquetasReimpresas" class="table-wrapper no-m-bottom">
        <table >
            <thead>
                <tr>
                    <th class="string sortable sortable-bigger" [appSort]="dataDisplayed" data-order="desc" data-name="desPais" (click)="toOrderBy(1)">
                        {{'global.pais' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(1)"></i>
                        </div>
                    </th>
                    <th class="string sortable sortable-bigger" [appSort]="dataDisplayed" data-order="desc" data-name="desDenominacion" (click)="toOrderBy(2)">
                        {{'central-avisos.etiquetadores.etiquetasReimpresas.denominacion' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(2)"></i>
                        </div>
                    </th>
                    <th class="string sortable sortable-biggest" [appSort]="dataDisplayed" data-order="desc" data-name="desEtiquetador" (click)="toOrderBy(3)">
                        {{'central-avisos.etiquetadores.etiquetasReimpresas.etiquetador' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(3)"></i>
                        </div>
                    </th>
                    <th class="number sortable sortable-bigger" [appSort]="dataDisplayed" data-order="desc" data-name="numeroEtiquetasReimpresas" (click)="toOrderBy(4)">
                        {{'central-avisos.etiquetadores.etiquetasReimpresas.reimpresiones' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(4)"></i>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody *ngFor="let row of dataDisplayed; let i = index">
                <tr *ngIf="i < lastItemList && i >= firstItemList">
                    <td class="string">{{row.desPais}}</td>
                    <td class="string">{{row.desDenominacion}}</td>
                    <td class="string-longest">{{row.desEtiquetador}}</td>
                    <td class="number">{{row.numeroEtiquetasReimpresas | number : '1.0-0': defaultLanguage}}</td>
                </tr>
            </tbody>
            <tfoot *ngIf="!dataDisplayed || (dataDisplayed && dataDisplayed.length < 1)">
                <tr>
                  <td colspan="4">
                    {{'global.noContent' | translate}}
                  </td>
                </tr>
            </tfoot>
        </table>
    </div>
    
    <div *ngIf="showConfecciones" class="table-wrapper no-m-bottom">
        <table>
            <thead>
                <tr>
                    <th class="string sortable sortable-bigger" [appSort]="dataDisplayed" data-order="desc" data-name="desPais" (click)="toOrderBy(1)">
                        {{'global.pais' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(1)"></i>
                        </div>
                    </th>
                    <th class="string sortable sortable-bigger" [appSort]="dataDisplayed" data-order="desc" data-name="desDenominacion" (click)="toOrderBy(2)">
                        {{'central-avisos.etiquetadores.confecciones.denominacion' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(2)"></i>
                        </div>
                    </th>
                    <th class="string sortable sortable-biggest" [appSort]="dataDisplayed" data-order="desc" data-name="desEtiquetador" (click)="toOrderBy(3)">
                        {{'central-avisos.etiquetadores.confecciones.etiquetador' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(3)"></i>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody *ngFor="let row of dataDisplayed; let i = index">
                <tr *ngIf="i < lastItemList && i >= firstItemList">
                    <td class="string">{{row.desPais}}</td>
                    <td class="string">{{row.desDenominacion}}</td>
                    <td class="string-longest">{{row.desEtiquetador}}</td>
                </tr>
            </tbody>
            <tfoot *ngIf="!dataDisplayed || (dataDisplayed && dataDisplayed.length < 1)">
                <tr>
                  <td colspan="3">
                    {{'global.noContent' | translate}}
                  </td>
                </tr>
            </tfoot>
        </table>
    </div>
    
    <div *ngIf="showDenominacionesBloqueadas" class="table-wrapper no-m-bottom">
        <table>
            <thead>
                <tr>
                    <th class="string sortable sortable-bigger" [appSort]="dataDisplayed" data-order="desc" data-name="desPais" (click)="toOrderBy(1)">
                        {{'global.pais' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(1)"></i>
                        </div>
                    </th>
                    <th class="string sortable sortable-bigger" [appSort]="dataDisplayed" data-order="desc" data-name="desDenominacion" (click)="toOrderBy(2)">
                        {{'central-avisos.etiquetadores.denominacionesBloqueadas.denominacion' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(2)"></i>
                        </div>
                    </th>
                    <th class="string sortable sortable-biggest" [appSort]="dataDisplayed" data-order="desc" data-name="desEtiquetador" (click)="toOrderBy(3)">
                        {{'central-avisos.etiquetadores.denominacionesBloqueadas.etiquetador' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(3)"></i>
                        </div>
                    </th>
                    <th class="date sortable sortable-bigger" [appSort]="dataDisplayed" data-order="desc" data-name="fechaImpresionDesautorizado" data-type="date" (click)="toOrderBy(4)">
                        {{'central-avisos.etiquetadores.denominacionesBloqueadas.fechaBloqueo' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(4)"></i>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody *ngFor="let row of dataDisplayed; let i = index">
                <tr *ngIf="i < lastItemList && i >= firstItemList">
                    <td class="string">{{row.desPais}}</td>
                    <td class="string">{{row.desDenominacion}}</td>
                    <td class="string-longest">{{row.desEtiquetador}}</td>
                    <td class="date">{{row.fechaImpresionDesautorizado | date:"short": undefined : defaultLanguage}}</td>
                </tr>
            </tbody>
            <tfoot *ngIf="!dataDisplayed || (dataDisplayed && dataDisplayed.length < 1)">
                <tr>
                  <td colspan="4">
                    {{'global.noContent' | translate}}
                  </td>
                </tr>
            </tfoot>
        </table>
    </div>
    
    <div *ngIf="showFallosConexion" class="table-wrapper no-m-bottom">
        <table>
            <thead>
                <tr>
                    <th class="string sortable sortable-bigger" [appSort]="dataDisplayed" data-order="desc" data-name="desPais" (click)="toOrderBy(1)">
                        {{'global.pais' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(1)"></i>
                        </div>
                    </th>
                    <th class="string sortable sortable-bigger" [appSort]="dataDisplayed" data-order="desc" data-name="desDenominacion" (click)="toOrderBy(2)">
                        {{'central-avisos.etiquetadores.fallosConexion.denominacion' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(2)"></i>
                        </div>
                    </th>
                    <th class="string sortable sortable-biggest" [appSort]="dataDisplayed" data-order="desc" data-name="desEtiquetador" (click)="toOrderBy(3)">
                        {{'central-avisos.etiquetadores.fallosConexion.etiquetador' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(3)"></i>
                        </div>
                    </th>
                    <th class="date sortable sortable-biggest" [appSort]="dataDisplayed" data-order="desc" data-name="consumoFechaImpresion" data-type="date" (click)="toOrderBy(4)">
                        {{'central-avisos.etiquetadores.fallosConexion.fechaDesconexion' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(4)"></i>
                        </div>
                    </th>
                    <th class="date sortable sortable-bigger" [appSort]="dataDisplayed" data-order="desc" data-name="consumoFechaIns" data-type="date" (click)="toOrderBy(5)">
                        {{'central-avisos.etiquetadores.fallosConexion.fechaConexion' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(5)"></i>
                        </div>
                    </th>
                    <th class="string sortable sortable-bigger" [appSort]="dataDisplayed" data-order="desc" data-name="consumoFechaImpresion" (click)="toOrderBy(6)">
                        {{'central-avisos.etiquetadores.fallosConexion.sinConexion' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(6)"></i>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody *ngFor="let row of dataDisplayed; let i = index">
                <tr *ngIf="i < lastItemList && i >= firstItemList">
                    <td class="string">{{row.desPais}}</td>
                    <td class="string">{{row.desDenominacion}}</td>
                    <td class="string-longest">{{row.desEtiquetador}}</td>
                    <td class="date">{{row.consumoFechaImpresion | date:"short" : undefined : defaultLanguage}}</td>
                    <td class="date">{{row.consumoFechaIns | date:"short" : undefined : defaultLanguage}}</td>
                    <td class="string">{{row.periodoTiempo}}</td>
                </tr>
            </tbody>
            <tfoot *ngIf="!dataDisplayed || (dataDisplayed && dataDisplayed.length < 1)">
                <tr>
                  <td colspan="6">
                    {{'global.noContent' | translate}}
                  </td>
                </tr>
            </tfoot>
        </table>
    </div>
    
    <div *ngIf="showUsuariosActivos" class="table-wrapper no-m-bottom">
        <table>
            <thead>
                <tr>
                    <th class="string sortable sortable-biggest" [appSort]="dataDisplayed" data-order="desc" data-name="userName" (click)="toOrderBy(1)">
                        {{'central-avisos.etiquetadores.usuariosActivos.usuario' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(1)"></i>
                        </div>
                    </th>
                    <th class="string sortable sortable-biggest" [appSort]="dataDisplayed" data-order="desc" data-name="nombre" (click)="toOrderBy(2)">
                        {{'central-avisos.etiquetadores.usuariosActivos.nombre' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(2)"></i>
                        </div>
                    </th>
                    <th class="string sortable sortable-bigger" [appSort]="dataDisplayed" data-order="desc" data-name="apellido" (click)="toOrderBy(3)">
                        {{'central-avisos.etiquetadores.usuariosActivos.apellido' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(3)"></i>
                        </div>
                    </th>
                    <th class="date sortable sortable-bigger" [appSort]="dataDisplayed" data-order="desc" data-name="ultFechaActividad" data-type="date" (click)="toOrderBy(4)">
                        {{'central-avisos.etiquetadores.usuariosActivos.ultimaActividad' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(4)"></i>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody *ngFor="let row of dataDisplayed; let i = index">
                <tr *ngIf="i < lastItemList && i >= firstItemList">
                    <td class="string-longest">{{row.userName}}</td>
                    <td class="string-longest">{{row.nombre}}</td>
                    <td class="string">{{row.apellido}}</td>
                    <td class="date">{{row.ultFechaActividad | date:"short" : undefined : defaultLanguage}}</td>
                </tr>
            </tbody>
            <tfoot *ngIf="!dataDisplayed || (dataDisplayed && dataDisplayed.length < 1)">
                <tr>
                  <td colspan="11">
                    {{'global.noContent' | translate}}
                  </td>
                </tr>
            </tfoot>
        </table>
    </div>
    
    <div *ngIf="showActivosImprimiendo" class="table-wrapper no-m-bottom">
        <table>
            <thead>
                <tr>
                    <th class="string sortable sortable-biggest" [appSort]="dataDisplayed" data-order="desc" data-name="desEtiquetador" (click)="toOrderBy(1)">
                        {{'central-avisos.etiquetadores.activosImprimiendo.etiquetador' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(1)"></i>
                        </div>
                    </th>
                    <th class="date sortable sortable-bigger" [appSort]="dataDisplayed" data-order="desc" data-name="ultFechaImpresion" data-type="date" (click)="toOrderBy(2)">
                        {{'central-avisos.etiquetadores.activosImprimiendo.ultimaActividad' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(2)"></i>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody *ngFor="let row of dataDisplayed; let i = index">
                <tr *ngIf="i < lastItemList && i >= firstItemList">
                    <td class="string-longest">{{row.desEtiquetador}}</td>
                    <td class="date">{{row.ultFechaImpresion | date:"short" : undefined : defaultLanguage}}</td>
                </tr>
            </tbody>
            <tfoot *ngIf="!dataDisplayed || (dataDisplayed && dataDisplayed.length < 1)">
                <tr>
                  <td colspan="11">
                    {{'global.noContent' | translate}}
                  </td>
                </tr>
            </tfoot>
        </table>
    </div>
    
    <div *ngIf="showAlmacenes" class="table-wrapper no-m-bottom">
        <table>
            <thead>
                <tr>
                    <th class="string sortable sortable-biggest" [appSort]="dataDisplayed" data-order="desc" data-name="des" (click)="toOrderBy(1)">
                        {{'central-avisos.etiquetadores.almacenes.etiquetador' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(1)"></i>
                        </div>
                    </th>
                    <th class="string sortable sortable-biggest" [appSort]="dataDisplayed" data-order="desc" data-name="lsDesAlmacen" (click)="toOrderBy(2)">
                        {{'central-avisos.etiquetadores.almacenes.almacenes' | translate}}
                        <div class="sortable-icons">
                            <i [ngClass]="getSortIcon(2)"></i>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody *ngFor="let row of dataDisplayed; let i = index">
                <tr *ngIf="i < lastItemList && i >= firstItemList">
                    <td class="string-longest">{{row.des}}</td>
                    <td class="string-longest">{{row.lsDesAlmacen}}</td>
                </tr>
            </tbody>
            <tfoot *ngIf="!dataDisplayed || (dataDisplayed && dataDisplayed.length < 1)">
                <tr>
                  <td colspan="11">
                    {{'global.noContent' | translate}}
                  </td>
                </tr>
            </tfoot>
        </table>
    </div>
    
    <app-paginator
        *ngIf="(dataDisplayed && dataDisplayed.length > 0) || (dataExpedicionCeroDiasDisplayed && dataExpedicionCeroDiasDisplayed.length > 0)"
        [itemsPerPage]="itemsPerPage" [currentPage]="currentPage" [totalItems]="totalItems"
        [visiblePages]="visiblePages" (pageChange)="pageChange($event)"
        (itemsPerPageChange)="itemsPerPageChange($event)"></app-paginator>
</content>
<footer class="button-bar-right">
    <button (click)="close()">{{'global.cerrar' | translate}}</button>
</footer>
